import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { aiKeys } from '@core/react-query/features/ai/aiKeys'

export const useFillWorkflow = (
  options?: UseMutationOptions<
    any,
    RequestErrorType,
    RequestTypes['fillWorkflow']
  >,
) => {
  return useMutation({
    ...aiKeys.fillWorkflow,
    ...options,
  })
}
